import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { PackageSummary } from '../../../../shared/organizationPackages/response';

const fetchPackageSummary = () => get<PackageSummary>('/api/packages/package-summary', true);

export const packageSummaryQueryKey = ['packages', 'package-summary'];

export default function usePackageSummary() {
  return useQuery<PackageSummary>({
    queryKey: packageSummaryQueryKey,
    queryFn: fetchPackageSummary,
    staleTime: 1000 * 60 * 5,
  });
}
